import { primitive } from 'styles/constants';
const theme = {
  envTitleColor: primitive.$greyOne,
};

export default theme;
